module.exports = __webpack_public_path__ + "static/img/ent-85.28c6aef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-85.jpg
// module id = d7Hf
// module chunks = 52